import { Modal } from "ant-design-vue";

const originalFetch = window.fetch;
let isRedirecting = false;
let hasRedirected = false;

const redirectToLogin = () => {
    if (hasRedirected) return;
    hasRedirected = true;
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = `${process.env.VUE_APP_authority}/Account/Login`;
};

window.fetch = async (...args: Parameters<typeof fetch>): Promise<Response> => {
    const response = await originalFetch(...args);
    if (response.status === 401 && !isRedirecting) {
        const input = args[0];

        const url =  typeof input === "string" ? input : input instanceof URL ? input.href : input.url;
        
        const isAuthCall =
            url.toLowerCase().includes("account/login") ||
            url.toLowerCase().includes("/auth") ||
            url.toLowerCase().includes("verifynewsession");

        const onLoginPage =
            window.location.pathname.toLowerCase().startsWith("/account/login");

        if (!isAuthCall && !onLoginPage && !url.toLowerCase().includes("quicksight-embed-url")) {
            isRedirecting = true;
            try {
                const oidcUserData = sessionStorage.getItem('OIDC_USER');
                let email = '';
                if (oidcUserData) {
                    const oidcUser = JSON.parse(oidcUserData);
                    email = oidcUser?.profile?.preferred_username ?? '';
                }

                let isNewSessionActive = false;
                if (email) {
                    const verifyResponse = await originalFetch(
                        `${process.env.VUE_APP_authority}/Account/VerifyNewSession`,
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/x-www-form-urlencoded"
                            },
                            body: `email=${encodeURIComponent(email)}`
                        }
                    );
                    const result = await verifyResponse.json();
                    isNewSessionActive = result.isNewSessionActive;
                }
                Modal.info({
                    title: "Session Expired",
                    content: isNewSessionActive
                        ? "Another active session has been detected for this account."
                        : "Your session has expired. Please login again.",
                    okText: "Ok",
                    maskClosable: false,
                    closable: false,
                    centered: true,
                    keyboard: false,
                    onOk() {
                        redirectToLogin();
                    }
                });
                setTimeout(() => {
                    redirectToLogin();
                }, 5000);
            }
            catch {
                Modal.info({
                    title: "Session Expired",
                    content: "Your session has expired. Please login again.",
                    okText: "Login",
                    maskClosable: false,
                    closable: false,
                    centered: true,
                    keyboard: false,
                    onOk() {
                        redirectToLogin();
                    }
                });
                setTimeout(() => {
                    redirectToLogin();
                }, 5000);
            }
        }
    }
    return response;
};